// export const baseURL = 'https://us-central1-bypal-adffb.cloudfunctions.net/api/';

module.exports = {
  // baseURL: 'https://us-central1-bypal-adffb.cloudfunctions.net/api/',
  baseURL: 'https://bypal-prod-server.appspot.com/api/',
  // baseURL: 'http://localhost:3000/api/',

  googleAnalyticsId: 'UA-75060123-4'
};
